import stationDataConfigApi from '@/api/config/stationDataConfig'
import { queryKeys } from '@/constant/common'
import { DecoderReading } from '@/types/decoder'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

function useStationLineUnitDecoder(
  interfaceId: number,
  lineId: number,
  ioId: number,
  twiId?: number,
  options?: Omit<
    UseQueryOptions<DecoderReading | null>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery<DecoderReading | null>(
    [queryKeys.stations, interfaceId, lineId, ioId],
    async () => {
      if (!interfaceId || !lineId || !ioId) return null
      const { data } = await stationDataConfigApi.getStationLineUnitDecoder({
        interfaceId,
        lineId,
        ioId,
        twiId,
      })
      if (!data) return null

      return data
    },
    {
      cacheTime: 0,
      enabled: false,
      ...(options && options),
    },
  )
}

export default useStationLineUnitDecoder
